import Dropdown from 'components/base/Dropdown';
import { StyledDropDownContainer } from '../EditSection/EditSection.style';
import toUpper from 'lodash/toUpper';
import { METRICS_CALCULATION_STRATEGY } from 'common/constants/constants';
import {
  CALCULATION_STRATEGY_SETTING_KEY,
  getCalculationStrategyKey
} from '../../utils/calculationStrategy';
import { useDispatch, useSelector } from 'react-redux';
import { myAccountSelector } from 'state/selectors/account';
import { patchAccount } from 'state/callers';
import useSettingsService from 'components/hooks/useSettingsService';
import { FEATURE_FLAGS_NAMES, MEDIAN_VALUES } from '@linearb/linjs-common';

const EditCalculationStrategy = ({
  onAggChange,
  widget,
  isMedian,
  isHover
}) => {
  const account = useSelector(myAccountSelector) || {};
  const dispatch = useDispatch();
  const { getSettingOrDefinitionValue } = useSettingsService();

  const p90AggregationEnabled = getSettingOrDefinitionValue({
    name: FEATURE_FLAGS_NAMES.p90AggregationEnabled
  });

  // no need to show in case metrics is not median or it's not hover on non-new mode
  if (!isMedian || !(widget.isNewReport || isHover)) {
    return null;
  }

  const onChange = async value => {
    onAggChange(value);
    await patchAccount(account.id, {
      settings: Object.assign(account?.settings, {
        [CALCULATION_STRATEGY_SETTING_KEY]: {
          ...(account?.settings?.[CALCULATION_STRATEGY_SETTING_KEY] ?? {}),
          [getCalculationStrategyKey(widget.report, widget.name)]: value
        }
      })
    })(dispatch);
  };

  return (
    <StyledDropDownContainer>
      <Dropdown
        width='100%'
        onChange={onChange}
        placeholder={toUpper(widget.agg ?? 'avg')}
        options={METRICS_CALCULATION_STRATEGY.filter(
          item => p90AggregationEnabled || item.value !== MEDIAN_VALUES.p90
        ).map(({ value }) => ({
          value,
          displayValue: toUpper(value)
        }))}
      />
    </StyledDropDownContainer>
  );
};

export default EditCalculationStrategy;
